import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propStr } from '../../../../helpers/custom-prop-types';
import { validateContent } from '../../../../validate/solution_order';
import PlainTextAreaComponent from '../../Common/PlainTextAreaComponent';
const OrderContentField = ({ name }) => (_jsx(Field, { component: PlainTextAreaComponent, name: name, props: {
        className: 'input-form-textarea is-inquiry',
        placeholder: '質問や依頼したい内容をご記入ください。',
    }, validate: validateContent }));
OrderContentField.propTypes = {
    name: propStr().isRequired,
};
export default OrderContentField;
